
import { ref } from '@vue/composition-api';
import type { FilterGroupValue } from '~/type/Filter';
const __sfc_main = {};
__sfc_main.props = {
  active: {
    key: "active",
    required: false,
    type: Boolean,
    default: false
  },
  isFilterSelected: {
    key: "isFilterSelected",
    required: false,
    type: Boolean,
    default: false
  },
  filters: {
    key: "filters",
    required: true,
    type: Array
  }
};
__sfc_main.setup = (__props, __ctx) => {
  const arr = ref('');
  function selectedFilters(data: string[]) {
    /**
    * Возвращает массив выбранных фильтров в красивом виде, через запятую и пробел
    */
    return arr.value = data.join(', ');
  }
  return {
    selectedFilters
  };
};
export default __sfc_main;
